import { BinaryFiles } from '@excalidraw/excalidraw/types/types';
import { useQuery } from '@tanstack/react-query';
import Axios from 'axios';

import BackendService from '../services/backendService';
import { RoundMediaDrawingFile } from '../services/backendService/types';

type FileWithDataURL = RoundMediaDrawingFile & { dataURL: string };

function toBinaryFiles(d: FileWithDataURL[]): BinaryFiles {
  return d.reduce((acc, cur) => {
    return {
      ...acc,
      [cur.id]: cur,
    };
  }, {});
}

export const useGameDrawingBackgroundFiles = (files?: RoundMediaDrawingFile[] | null) => {
  const { data, isFetching, error } = useQuery(
    ['game-file', files ? files.map(f => f.id) : undefined],
    async () => {
      if (!files) return Promise.resolve(undefined);
      const res = await Promise.all(
        files.map(async f => {
          const downloadRes = await BackendService.instance.getDownloadUrl(f.id);
          const url = downloadRes.data.url;
          const res = await Axios.request<Blob>({
            method: 'get',
            url,
            responseType: 'blob',
          });
          const objUrl = URL.createObjectURL(res.data);
          return { ...f, dataURL: objUrl };
        }),
      );

      return toBinaryFiles(res.filter(r => !!r.dataURL) as FileWithDataURL[]);
    },
    {
      enabled: Boolean(files),
      staleTime: 1000 * 60 * 5,
    },
  );

  return {
    data,
    isLoading: isFetching,
    error,
  };
};
